module.exports = __webpack_public_path__ + "static/media/ru.13a137b8.svg";